// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/lists/evaluationsList/evaluationsList.scss
// module id = 550
// module chunks = 0